var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullcontainer",staticStyle:{"position":"absolute"}},[_c('div',{staticClass:"PicturePageConti"},[_c('img',{staticClass:"picturebg",attrs:{"src":_vm.centerPicSrc}})])])}
var staticRenderFns = []

export { render, staticRenderFns }